import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import {
  fetchMyPremiumTrialsQueryOptions,
  fetchMyRecurringTrialsQueryOptions
} from "services/trialsService/queries";

import { isSignedIn } from "seneca-common/features/user/state";

import {
  getRemainingDailyFreeExamQuestions,
  getRemainingPremiumTrialExamQuestions
} from "features/exam-questions/logic/selectors";
import { getNumExamQuestionGifts } from "features/gifts/state";

import type useHasAccessToExamQuestions from "./useHasAccessToExamQuestions";

/**
 * @deprecated use `useHasAccessToExamQuestions` instead
 * {@link useHasAccessToExamQuestions}
 */
export function useRemainingExamQuestions() {
  const userIsSignedIn = useSelector(isSignedIn);
  const {
    data: dailyFreeExamQuestions = 0,
    isLoading: isDailyFreeExamQuestionsLoading
  } = useQuery({
    ...fetchMyRecurringTrialsQueryOptions(),
    select: getRemainingDailyFreeExamQuestions,
    enabled: userIsSignedIn
  });

  const {
    data: premiumTrialExamQuestions = 0,
    isLoading: isPremiumTrialExamQuestionsLoading
  } = useQuery({
    ...fetchMyPremiumTrialsQueryOptions(),
    select: getRemainingPremiumTrialExamQuestions,
    enabled: userIsSignedIn
  });

  return {
    remainingQuestionsCount:
      dailyFreeExamQuestions +
      (premiumTrialExamQuestions ?? 0) +
      getNumExamQuestionGifts(),
    isLoading:
      isDailyFreeExamQuestionsLoading || isPremiumTrialExamQuestionsLoading
  };
}
